// The fun-name generator (PRD §8). Locally-flavoured English/Afrikaans/SA words.
// Username = two words in PascalCase (e.g. LekkerBakkie). Password = one funny word.
// Keep the banks friendly; grow them over time. BLOCKLIST is a safety net so future
// edits can't accidentally produce something crude.

const ADJECTIVES = [
  "Lekker", "Kief", "Kwaai", "Dapper", "Blink", "Warm", "Wilde", "Groot", "Klein",
  "Stout", "Slim", "Honger", "Moeg", "Vrolik", "Rustig", "Oulik", "Parmantig",
  "Spoggerig", "Windgat", "Deurmekaar", "Bakgat", "Woes", "Taai", "Sag", "Vinnige",
  "Snaakse", "Wakker", "Dowwe", "Swaar", "Ligte", "Dorstige", "Jolige", "Sonnige",
];

const NOUNS = [
  "Bakkie", "Padkos", "Veldskoen", "Mielie", "Gogga", "Rooibos", "Bergwind", "Sakkie",
  "Tannie", "Oom", "Koeksister", "Biltong", "Kloof", "Karoo", "Fynbos", "Dorp",
  "Boerseun", "Plaas", "Dassie", "Springbok", "Braai", "Potjie", "Boerewors",
  "Vetkoek", "Melktert", "Naartjie", "Lemoen", "Pampoen", "Brak", "Kraal", "Stoep",
  "Windpomp", "Trekker", "Veld", "Koppie", "Spruit", "Poort", "Snoek", "Meerkat",
  "Bobbejaan", "Luiperd", "Donkie", "Perske", "Waatlemoen", "Kalbas", "Tarentaal",
];

const PASSWORD_WORDS = [
  "koeksister", "vetkoek", "boerewors", "naartjie", "gogga", "dwaal", "snoek",
  "potjie", "mampoer", "witblits", "babbelas", "kuier", "sjoe", "hoezit", "aweh",
  "jislaaik", "mahala", "bakgat", "kief", "lekker", "skelm", "mieliepap", "pampoen",
  "brak", "veldskoen", "biltong", "rooibos", "sokkie", "vastrap", "boeretroos",
  "padkos", "eish", "dassie", "koppie", "windpomp",
];

const BLOCKLIST = ["poes", "fok", "naai", "piel", "doos", "kak", "hoer"];

function pick<T>(arr: readonly T[]): T {
  return arr[Math.floor(Math.random() * arr.length)]!;
}

function clean(word: string): boolean {
  const lower = word.toLowerCase();
  return !BLOCKLIST.some((bad) => lower.includes(bad));
}

/** Two locally-flavoured words in PascalCase, e.g. `LekkerBakkie`. */
export function generateUsername(): string {
  for (let i = 0; i < 25; i++) {
    const candidate = pick(ADJECTIVES) + pick(NOUNS);
    if (clean(candidate)) return candidate;
  }
  return "LekkerBakkie";
}

/** A single funny local word, e.g. `koeksister`. */
export function generatePassword(): string {
  for (let i = 0; i < 25; i++) {
    const candidate = pick(PASSWORD_WORDS);
    if (clean(candidate)) return candidate;
  }
  return "koeksister";
}
